import { setLocalUserInfoApi, getLocalUserInfoApi } from '@/utils/storage'
export default {
  // 开启命名空间
  namespaced: true,
  state () {
    return {
      // 首次进入页面时优先从本地获取
      userInfo: getLocalUserInfoApi()
    }
  },
  mutations: {
    setUserInfo (state, obj) {
      // 保存到state中
      state.userInfo = obj
      // 保存到本地
      setLocalUserInfoApi(obj)
    }
  },
  actions: {
    logOut (context) {
      context.commit('setUserInfo', {})
      // vuex的子模块如果要跨模块调用另一个模块的方法，需要加上 { root: true }
      context.commit('cart/setCartList', [], { root: true })
      context.commit('address/setReceivedAddressList', [], { root: true })
    }
  },
  getters: {

  }
}
